// composables/useMenuItems.ts
import { rolesRoutes } from '~/data/rolesRoutes'
export async function useMenuItems(locale: string) {
  
  let menuItems: any[] = []
  
  switch (locale) {
    case 'es':
      menuItems = (await import('~/data/menuItems-es')).menuItems
      break
    case 'en':
    default:
      menuItems = (await import('~/data/menuItems-en')).menuItems
      break
  }

  let idRol = JSON.parse(localStorage.getItem("rla-auth")|| "[{}]").user.idRol
  let rol = JSON.parse(localStorage.getItem("rla-auth")|| "[{}]").user.rol

  // Función recursiva para filtrar por rol
  const filterMenuByRole = (menu: any[]): any[] => {
    const roleObj = rolesRoutes.find(r => r.role === rol)
    if (!roleObj) return []

    return menu
      .map(item => {
        const newItem: any = { ...item }

        // Filtrar children recursivamente
        if (item.children) {
          newItem.children = filterMenuByRole(item.children)
        }

        // Validar acceso si tiene ruta
        if (item.to) {
          if (!(roleObj.allowedRoutes.includes('*') || roleObj.allowedRoutes.includes(item.to))) {
            return null
          }
        }

        // Eliminar items sin children y sin to
        if (newItem.children?.length === 0 && !newItem.to) return null

        return newItem
      })
      .filter(Boolean)
  }

  return filterMenuByRole(menuItems)
}
